import * as React from "react";
import PropTypes from "prop-types";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import SpeakerDetailControls from "./SpeakerDetailControls";
import SpeakerTileControls from "./SpeakerTileControls";

const Speaker = ({ isDetailed, ...props }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    {isDetailed ? (
      <SpeakerDetailControls {...props} />
    ) : (
      <SpeakerTileControls {...props} />
    )}
  </CommonControlWrapper>
);
Speaker.propTypes = {
  isDetailed: PropTypes.bool.isRequired,
};

export default Speaker;



// WEBPACK FOOTER //
// ./src/components/Controls/Speaker/index.jsx